
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "48px",
    "height": "48px",
    "viewBox": "0 0 48 48",
    "enable-background": "new 0 0 48 48",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "48",
        "height": "48"
      }
    },
    {
      "tag": "circle",
      "attrsMap": {
        "fill": "#B7C3D7",
        "cx": "24",
        "cy": "24",
        "r": "24"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFFFFF",
        "d": "M34.762,37.454H13.236c-1.98,0-3.588-1.607-3.588-3.588V17.722\r\n\tc0-1.981,1.607-3.587,3.588-3.587h5.381V12.34c0-0.99,0.805-1.793,1.795-1.793h7.176c0.99,0,1.793,0.803,1.793,1.793v1.795h5.381\r\n\tc1.982,0,3.588,1.605,3.588,3.587v16.145C38.35,35.847,36.744,37.454,34.762,37.454z M27.588,13.237\r\n\tc0-0.496-0.402-0.897-0.898-0.897h-5.381c-0.496,0-0.896,0.401-0.896,0.897v0.897c0.531,0,0.4,0,0.896,0h5.381\r\n\tc0.496,0,0.365,0,0.898,0V13.237z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#B7C3D7",
        "d": "M28.431,26.659c0.762,0,1.38-0.617,1.38-1.38s-0.618-1.38-1.38-1.38h-2.013l3.185-3.639\r\n\tc0.511-0.566,0.466-1.438-0.1-1.947c-0.566-0.512-1.438-0.463-1.949,0.104l-3.528,3.852l-3.591-3.877\r\n\tc-0.52-0.561-1.391-0.568-1.95-0.051c-0.56,0.517-0.595,1.445-0.079,2.005l3.209,3.554h-1.842c-0.762,0-1.379,0.617-1.379,1.38\r\n\ts0.617,1.38,1.379,1.38h2.791v1.569h-2.791c-0.762,0-1.379,0.618-1.379,1.38s0.617,1.38,1.379,1.38h2.791v1.138\r\n\tc0,0.85,0.688,1.539,1.539,1.539c0.85,0,1.538-0.689,1.538-1.539v-1.138h2.79c0.762,0,1.38-0.618,1.38-1.38s-0.618-1.38-1.38-1.38\r\n\th-2.79v-1.569H28.431z"
      }
    }
  ]
})
    }
  